export const resolvePlatformName = (entity, shopifyVersion) => {
    if (entity.platformName) {
        return entity.platformName;
    }
    if (entity.platformId) {
        return shopifyVersion === 2 ? "shopify" : "native";
    }
    return "";
};
